/*
 * Public API Surface of template-renderer
 */

export * from './lib/components/template-renderer/template-renderer.component';
export * from './lib/dialogs/template-export-dialog/template-export-dialog.component';
export * from './lib/dialogs/template-import-dialog/template-import-dialog.component';
export * from './lib/interfaces/template-configuration';
export * from './lib/pages/template-configurator/template-configurator.component';
export * from './lib/template.routes';
